import { CheckoutState } from '../reducers';

export const getEveryTravelService = (state: CheckoutState) => state.everyTravel;
